module.exports = __webpack_public_path__ + "img/error.bce512ef.png";